module.exports = __webpack_public_path__ + "img/list4.da28b349.png";